import { fg } from '@atlassian/jira-feature-gating';

const isCsmWorkItemAiSummariesEnabledRelayProvider = {
	get(): boolean {
		return fg('csm_work_item_ai_summaries');
	},
};

export default isCsmWorkItemAiSummariesEnabledRelayProvider;
